import React, { useEffect, useState } from "react";
import DocumentMeta from "react-document-meta";
import * as myConstList from "../../Common/BaseUrl";
import "react-phone-input-2/lib/bootstrap.css";
import axios from "axios";
import {
  isMobile,
  isDesktop,
  isAndroid,
  isIOS,
  browserName,
  browserVersion,
  osName,
  osVersion,
} from "react-device-detect";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ProductName } from "../../Common/ProductName";
import { PasswordValidation } from "../../Validation/PasswordValidation";
import { MobileValidation } from "../../Validation/MobileValidation";
import {
  useFgResetPassMutation,
  useFgSendOtpMutation,
  useFgVerifyOtpMutation,
} from "../../../redux/auth";
const baseUrl = myConstList.baseUrl;
const meta = {
  title: "Forgot | Green Crypto  Exchange ",
  description:
    "Green Crypto  Exchange Live Makes The Buying And Selling Of Crypto Coin Way More Effective And Profitable. We Are A Low Cost Cyrpto Exchange In India Like Bitcoin And Dogecoin.",
  canonical: "https://Green Crypto  Exchange.live/buy-sell-crypto-online",
  meta: {
    charset: "utf-8",
    name: {
      keywords:
        "BTC Exchange, Crypto Trading Platform, Best Crypto Converter, Indian Crypto Exchange",
    },
  },
};

const ForgotFunction = () => {
  const [handleState, setHandleState] = useState("");
  const [codeMatchedStatus, setCodeMatchedStatus] = useState(false);
  const [timerText, setTimerText] = useState("");
  const [counter, setCounter] = useState(0);
  const [textForCode, setTextForCode] = useState("Get Code");
  const [type, setType] = useState("password");
  const [type1, setType1] = useState("password");
  const [buttonDisableVerification, setButtonDisableVerification] =
    useState(true);

  const [VerificationCode, setVerificationCode] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [PasswordIssue, setPasswordIssue] = useState("");
  const [CPasswordIssue, setCPasswordIssue] = useState("");
  const [Password, setPassword] = useState("");
  const [CPassword, setCPassword] = useState("");
  const [disabledButton, setDisabledButton] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [verificationError, setVerificationError] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [EmailMessageErr, setEmailMessageErr] = useState("");
  const [disableButton, setDisableButton] = useState(false);
  const [disableGetCodeButton, setDisableGetCodeButton] = useState(false);

  const [fgSendOtp, { isLoading: sendingOtp }] = useFgSendOtpMutation();
  const [fgVerifyOtp, { isLoading: verifyingOtp }] = useFgVerifyOtpMutation();
  const [fgResetPass, { isLoading: resetingPass }] = useFgResetPassMutation();

  const handleChange2 = (event) => {
    var value = event.target.value;

    setTextForCode("");
    setTimerText("Get Code");
    setVerificationCode("");
    setHandleState(value);

    if (!value) {
      setMobileError("This field is required");
      setEmailError("");
      setMobile("");
      setEmail("");
      return false;
    }

    // 🔹 Check if numeric
    if (!isNaN(parseFloat(value)) && !isNaN(value - 0)) {
      // Allow 6 to 15 digits
      var phoneno = /^\d{6,15}$/;

      if (!phoneno.test(value)) {
        setMobileError("Please enter a valid mobile number");
        setEmailError("");
      } else {
        setMobileError("");
        setEmailError("");
      }

      setMobile(value);
      setEmail("");
    } else {
      // 🔹 Email validation
      var Email = value;
      if (
        new RegExp(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}$/i).test(Email)
      ) {
        setMobileError("");
        setEmailError("");
      } else {
        setMobileError("");
        setEmailError("Please enter a valid email address");
      }

      setMobile("");
      setEmail(value);
    }
  };

  const handleChangePasswordSubmit = async (event) => {
    event.preventDefault();

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$/;

    // Client-side validation
    if (!Password) {
      setPasswordIssue("This field is required");
      return;
    }

    if (!CPassword) {
      setCPasswordIssue("This field is required");
      return;
    }

    if (!passwordRegex.test(Password)) {
      setPasswordIssue(
        "Password must be at least 8 characters and include one uppercase, one lowercase, one number, and one special character."
      );
      return;
    }

    if (Password !== CPassword) {
      setCPasswordIssue("Password mis-matched");
      return;
    }

    if (PasswordIssue || CPasswordIssue) {
      return;
    }

    // Disable button for 5 seconds
    setDisabledButton(true);
    setTimeout(() => setDisabledButton(false), 5000);
    setDisableButton(true);
    const params = {
      password: CPassword,
    };

    const res = await fgResetPass(params);
    const { error, data } = res;

    if (error) {
      const errMsg = error?.data?.message || "Something went wrong";
      toast.error(errMsg);
      if (error.status == 403) {
        setTimeout(() => window.location.reload(), 1000);
        return;
      }

      setTimeout(() => setDisableButton(false), 4000);
      return;
    }

    if (data?.status === true) {
      toast.success(data.message || "Password reset successfully");
      setPassword("");
      setCPassword("");
      localStorage.removeItem("hemAuth");
      setTimeout(() => {
        window.location.href = "/login";
      }, 2000);
    } else {
      toast.error(data?.message || "Failed to reset password");
      setTimeout(() => setDisableButton(false), 4000);
    }
  };

  const handleMobileSubmit = async (e) => {
    e.preventDefault();

    // Early validation
    if (!mobile && !email && !VerificationCode) {
      setMobileError("This field is required");
      setEmailError("This field is required");
      setVerificationError("This field is required");
      return;
    }

    if (!mobile && !email) {
      setMobileError("This field is required");
      setEmailError("This field is required");
      return;
    }

    if (!VerificationCode) {
      setVerificationError("This field is required");
      return;
    }

    if (mobileError || emailError) {
      return;
    }

    setDisableButton(true);
    // Payload
    const payload = {
      type: mobile ? "phone" : "email",
      // country_code: "+91",
      phone: mobile || "",
      email: email || "",
      otp: VerificationCode,
    };

    // RTK Query call
    const res = await fgVerifyOtp(payload);
    const { error, data: resData } = res;

    // Error handling
    if (error) {
      const errMsg = error?.data?.message || "Verification failed";
      toast.error(errMsg);
      setTimeout(() => setDisableButton(false), 4000);
      return;
    }

    if (resData?.status) {
      toast.success(resData.message || "OTP verified successfully");
      setCodeMatchedStatus(true);
      setCPassword("");
      setDisableButton(false);
      setPassword("");
      localStorage.setItem("hemAuth", resData?.response?.token);
    } else {
      toast.error(resData?.message || "Invalid OTP");
      setCodeMatchedStatus(false);
      setTimeout(() => setDisableButton(false), 4000);
    }
  };

  const startCountdown = (seconds) => {
    let counter = seconds;
    const interval = setInterval(() => {
      setCounter(counter);
      setTimerText("Resend In");
      setBtnDisable(true);
      counter--;
      if (counter < 0) {
        clearInterval(interval);
        setBtnDisable(false);
        setTextForCode("Resend Code");
        setTimerText("");
        setDisableGetCodeButton(false);
      }
    }, 1000);
  };

  const handlecodechange = async (e) => {
    let { value } = e.target;

    if (value.length > 6) {
      return;
    }

    setVerificationCode(value);

    if (!value) {
      setVerificationError("This field is required");
    } else {
      setVerificationError("");
    }
  };

  const getCode = async () => {
    if (!email && !mobile) {
      setEmailError("This field is required");
      return;
    }

    if (emailError || mobileError) {
      return;
    }

    const registerData = {
      country_code: countryCode,
      phone: mobile || "",
      email: email || "",
      type: mobile ? "phone" : "email",
    };

    setDisableGetCodeButton(true);
    // RTK Query call
    const res = await fgSendOtp(registerData);

    const { data, error } = res;

    if (error) {
      const errMsg = error?.data?.message || "Something went wrong";
      toast.error(errMsg);
      setButtonDisableVerification(true);
      setTimeout(() => setDisableGetCodeButton(false), 4000);
      return;
    }

    if (data) {
      if (data.status === true) {
        toast.success(data.message || "OTP sent successfully");
        setEmailMessageErr(""); // Clear any previous error message
        startCountdown(30);
        setButtonDisableVerification(false);
      } else {
        toast.error(data.EmailMessage || data.message || "Failed to send OTP");
        setEmailMessageErr(data.EmailMessage || data.message);
        setButtonDisableVerification(true);
        setTimeout(() => setDisableGetCodeButton(false), 4000);
      }
    }
  };

  const handleClick = () => {
    if (type === "text") {
      setType("password");
    } else {
      setType("text");
    }
  };

  const handleClick1 = () => {
    if (type1 === "text") {
      setType1("password");
    } else {
      setType1("text");
    }
  };

  const handleChange101 = (event) => {
    let { name, value, id } = event.target;

    setErrMsg("");
    setTextForCode("Get Code");
    setTimerText("Get Code");

    // Password //
    if (name == "password") {
      setPassword(value);
      var passwordError = PasswordValidation(name, value);
      setPasswordIssue(passwordError);
      if (passwordError == "mismatched") {
        setCPasswordIssue("Password mis-matched");
        setPasswordIssue("");
      }
      if (passwordError == "") {
        // setCPassword("");
        setCPasswordIssue("");
      }
    }

    if (name == "cpassword") {
      setCPassword(value);
      var CpasswordError = PasswordValidation(name, value);
      setCPasswordIssue(CpasswordError);
      if (passwordError == "") {
        setCPasswordIssue("");
      }
    }
  };

  const handleValidation = (event) => {
    if (event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
    if (
      event.key === "-" ||
      event.key === "+" ||
      event.key === "!" ||
      event.key === "@" ||
      event.key === "#" ||
      event.key === "$" ||
      event.key === "%" ||
      event.key === "^" ||
      event.key === "&" ||
      event.key === "*" ||
      event.key === "(" ||
      event.key === ")"
    ) {
      event.preventDefault();
    }
  };

  const blockMobileKeys = (e) => {
    const invalid = [".", "Decimal", "e", "E", "+", "-", ","];
    if (invalid.includes(e.key)) e.preventDefault();
  };

  return (
    <DocumentMeta {...meta}>
      <div className="register-main-outer position-relative d-flex align-items-center flex-wrap">
        <span className="main-bg fadeInLeft animated"></span>
        <div className="register-inner">
          <div className="row m-0">
            <div className="col-12 p-0">
              <div className="register-right fadeInRight animated ">
                <div className="heading-link-outer">
                  <div className="heading">
                    <h2 className="m-0">Forgot Password</h2>
                  </div>
                </div>
                <div className="register-form">
                  {!codeMatchedStatus ? (
                    <form
                      onSubmit={handleMobileSubmit}
                      //   ref={(el) => (myFormRef = el)}
                    >
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group position-relative">
                            <label>Email</label>
                            <input
                              className="form-control"
                              type="text"
                              autoComplete="off"
                              placeholder="Enter Email"
                              name="Email"
                              maxLength={70}
                              value={handleState}
                              onChange={handleChange2}
                              // onBlur={handleOnBlurEmail.bind(this)}
                              disabled={counter == 0 ? false : true}
                            />
                            <div style={{ color: "red" }}>
                              {emailError || mobileError}
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <label>Verification Code</label>
                            <div className="get-outer position-relative">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter Verification Code"
                                name="VerificationCode"
                                onChange={handlecodechange}
                                onKeyDown={(e) => {
                                  handleValidation(e);
                                  blockMobileKeys(e);
                                }}
                                disabled={
                                  codeMatchedStatus || buttonDisableVerification
                                }
                                // onBlur={onBlurVerificationCode.bind(
                                //   this
                                // )}
                                value={VerificationCode}
                                aria-label="Input group example"
                                aria-describedby="btnGroupAddon"
                              />

                              <div className="get-btn position-absolute">
                                <button
                                  className="btn btn_man"
                                  id="btnGroupAddon"
                                  type="button"
                                  onClick={getCode}
                                  disabled={
                                    codeMatchedStatus ||
                                    btnDisable ||
                                    disableGetCodeButton
                                  }
                                >
                                  {timerText}
                                  {"  "}
                                  {counter == 0 ? textForCode : counter}
                                </button>
                              </div>
                            </div>
                            <div style={{ color: "red" }}>
                              {verificationError}
                            </div>
                          </div>
                        </div>
                        {!codeMatchedStatus && (
                          <div className="col-md-6 col-12">
                            <div className="form-group">
                              <button
                                className="btn btn_man"
                                disabled={disableButton}
                                type="submit"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </form>
                  ) : (
                    <form onSubmit={handleChangePasswordSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>New Password</label>
                            <div className="eye_pass">
                              <input
                                className="form-control"
                                type={type}
                                name="password"
                                id="Password"
                                placeholder="Enter Password"
                                // onBlur={handleBlurChange}
                                value={Password}
                                onChange={handleChange101}
                                maxLength={30}
                              />
                              <span
                                className="password__show eye1"
                                onClick={handleClick}
                              >
                                {type === "text" ? (
                                  <i className="las la-eye"></i>
                                ) : (
                                  <i className="las la-low-vision"></i>
                                )}
                              </span>
                              {PasswordIssue && (
                                <div style={{ color: "red" }}>
                                  {PasswordIssue}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <label>Confirm Password</label>

                            <div className="form-group eye_pass">
                              <input
                                className="form-control"
                                type={type1}
                                placeholder="Enter Confirm Password"
                                name="cpassword"
                                id="CPassword"
                                onChange={handleChange101}
                                value={CPassword}
                                maxLength={30}
                              />
                              <span
                                className="password__show eye1"
                                onClick={handleClick1}
                              >
                                {type1 === "text" ? (
                                  <i className="las la-eye"></i>
                                ) : (
                                  <i className="las la-low-vision"></i>
                                )}
                              </span>

                              {CPasswordIssue && (
                                <div style={{ color: "red" }}>
                                  {CPasswordIssue}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <button
                          className="btn w100 btn_man"
                          disabled={disableButton}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DocumentMeta>
  );
};

export default ForgotFunction;
